export default __webpack_public_path__ + "assets/instrucao-atendente-prd-component.560c725a.svg";